'use client';

import { createTRPCReact } from '@trpc/react-query';

import type { AppRouter } from 'backend/routers/app';

export const trpc = createTRPCReact<AppRouter>();
